import React from "react";
import {
  BackgroundImage,
  Box,
  Button,
  Flex,
  Grid,
  Image,
  Space,
  Stack,
  Text,
} from "@mantine/core";
import background from "assets/images/pngs/background.png";
import image11 from "@/assets/images/pngs/image11.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useSavingStore from "@/stores/SavingStore/savingStore";
import { beText } from "@/utils/beText";

type Props = {
  onBackStepOne?: () => void;
  dataStepThree?: { key: string; value: string; name: string }[];
};
const DepositSettlementStepThree: React.FC<Props> = ({
  onBackStepOne,
  dataStepThree,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [, actionSavingStore] = useSavingStore();
  return (
    <Flex justify="center">
      <Box
        sx={{
          background: "#ffffff",
          borderRadius: "16px",
          padding: "20px",
        }}
        w={782}
      >
        <Box w="100%">
          <BackgroundImage src={background} radius="md" className="w-full">
            <Stack spacing={0} style={{ alignItems: "center" }} p={10}>
              <Box w={140} h={88}>
                <Image src={image11} w={140} />
              </Box>
              <Text size={14} weight={800} sx={{ color: "white" }}>
                {t("REQUEST_SENT_AWAITING_APPROVAL")}
              </Text>
              <Text size={20} fw={600} sx={{ color: "white" }}>
                {dataStepThree?.[0]?.value ?? ""}
              </Text>
            </Stack>
          </BackgroundImage>
        </Box>
        <Space h={20} />
        <Grid gutter="md" align="flex-start">
          {dataStepThree &&
            dataStepThree.slice(1).map((item) => (
              <Grid.Col span={12} md={12} key={item.key}>
                <Flex justify="space-between">
                  <Text fz="sm" c="dimmed">
                    {beText(item.name)}
                  </Text>
                  <Text fz="sm" fw={500}>
                    {beText(item.value)}
                  </Text>
                </Flex>
              </Grid.Col>
            ))}
        </Grid>
        <Space h={20} />

        <Flex gap={10}>
          <Button
            sx={() => ({
              width: "50%",
              backgroundColor: "#F4F4F6",
              color: "#525866",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
              "&:hover": {
                backgroundColor: "#F4F4F6",
              },
            })}
            onClick={() => navigate("/")}
          >
            {t("HOME")}
          </Button>
          <Button
            type="submit"
            sx={() => ({
              width: "50%",
              backgroundColor: "#2A81D0",
              color: "white",
              borderRadius: "8px",
              padding: "8px 10px",
              cursor: "pointer",
              fontWeight: 400,
            })}
            onClick={() => {
              actionSavingStore.clearStore();
              onBackStepOne?.();
            }}
          >
            {t("CONFIRM")}
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default DepositSettlementStepThree;
